/* script */
//
//
//
//
//
//
//
//
//
//

// Utils
import PickedFile from 'shared/ui/components/form-components/pickers/picked-file';
import { loadCropper, canvasToBlob } from 'libs/utils/helpers/image';

// copperJs refers to this for max sizes: https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
const MAX_CANVAS_AREA = 268435456;
const MAX_CANVAS_HEIGHT_WIDTH = 32767;

/**
 * This component is used to crop images.
 *
 * @vue-prop {String} uid the unique identifier of the image
 * @vue-prop {String} src the input image url
 * @vue-prop {String} name the output image name
 * @vue-prop {String} type the input/output image type
 * @vue-prop {Number} [ratio] the output image w/h ratio
 * @vue-prop {Number} [width] the output image width
 * @vue-prop {Number} [height] the output image height
 * @vue-prop {Number} [maxWidth] the output image max-width
 * @vue-prop {Number} [maxHeight] the output image max-height
 *
 * @vue-event {File} cropped when the given image is successfully cropped
 * @vue-event {Void} complete when the component completes its task (cancel or save)
 *
 * @category ui.components.editors
 * @exports ImageCropper
 */
const __vue_script__ = {
    name: 'ImageCropper',

    props: {
        uid: {
            type: String,
            required: true
        },

        src: {
            type: String,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        type: {
            type: String,
            required: true
        },

        ratio: {
            type: Number,
            default: null
        },

        width: {
            type: Number,
            default: undefined
        },

        height: {
            type: Number,
            default: undefined
        },

        maxWidth: {
            type: Number,
            default: Infinity
        },

        maxHeight: {
            type: Number,
            default: Infinity
        }
    },

    data() {
        return {
            cropper: null,
            data: null
        };
    },

    async beforeDestroy() {
        // Release the kraken
        if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
        }
    },

    methods: {
        async createCropper() {
            this.cropper = await loadCropper(this.$refs.image, { aspectRatio: this.ratio });
            if (this.$refs.image) {
                this.$refs.image.cropper = this.cropper;
            }
        },

        /**
         * Applies the modification to the image.
         */
        async save() {
            if (!this.cropper) {
                console.warn('[ImageCropper] Cannot save without a cropper instance');
                return;
            }

            const maxHeightForRatio = Math.floor(Math.sqrt(MAX_CANVAS_AREA / this.ratio));
            const maxWidthForRatio = Math.floor(maxHeightForRatio * this.ratio);

            const crop = this.cropper.getCroppedCanvas({
                width: this.width,
                height: this.height,
                maxWidth: Math.min(this.maxWidth, maxWidthForRatio, MAX_CANVAS_HEIGHT_WIDTH),
                maxHeight: Math.min(this.maxHeight, maxHeightForRatio, MAX_CANVAS_HEIGHT_WIDTH),
                minWidth: 1,
                minHeight: 1,
            });

            const blob = await canvasToBlob(crop, this.type);
            const file = new PickedFile(blob, this.name, { type: this.type }, this.uid);

            // If we're at this stage, file we started cropping from has already
            // been validated, therefore we force new file validity to true
            file.validated = true;

            this.$emit('cropped', file);
        },

        /**
         * Cancels the image editing
         */
        cancel() {
            this.$emit('cancel');
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-cropper" }, [
    _vm.cropper
      ? _c("div", { staticClass: "toolbar" }, [
          _c("div", { staticClass: "btn-group" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$t("general.cancel"),
                    expression: "$t('general.cancel')",
                  },
                ],
                staticClass: "btn btn-mini btn-icon single cancel",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.cancel.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "ic-x" })]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-mini btn-primary save",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.apply")))]
            ),
          ]),
        ])
      : _vm._e(),
    _c("img", {
      ref: "image",
      attrs: { src: _vm.src, alt: _vm.name },
      on: { load: _vm.createCropper },
    }),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/editors/images/ImageCropper.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__